import { SessionRequest } from '../dto/session-request';

/**
 * Session holds session information returned from the backend
 */
export class Session {
  private _sessionGuid: string;
  private _expiresAt: Date;
  private _amount: number;
  private _monthlyPayment: number;
  private _monthsLong: number;
  private _processingFee: number;
  private _monthlyPaymentWithProcessingFee: number;

  constructor(
    sessionGuid: string,
    expiresAt: Date,
    amount: number,
    monthlyPayment: number,
    monthsLong: number,
    processingFee: number,
    monthlyPaymentWithProcessingFee: number,
  ) {
    this._sessionGuid = sessionGuid;
    this._expiresAt = expiresAt;
    this._amount = amount;
    this._monthlyPayment = monthlyPayment;
    this._monthsLong = monthsLong;
    this._processingFee = processingFee;
    this._monthlyPaymentWithProcessingFee = monthlyPaymentWithProcessingFee;
  }

  // Getters and setters

  get sessionGuid(): string {
    return this._sessionGuid;
  }

  set sessionGuid(value: string) {
    this._sessionGuid = value;
  }

  get expiresAt(): Date {
    return this._expiresAt;
  }

  set expiresAt(value: Date) {
    this._expiresAt = value;
  }

  get amount(): number {
    return this._amount;
  }

  set amount(value: number) {
    this._amount = value;
  }

  get monthlyPayment(): number {
    return this._monthlyPayment;
  }

  set monthlyPayment(value: number) {
    this._monthlyPayment = value;
  }

  get monthsLong(): number {
    return this._monthsLong;
  }

  set monthsLong(value: number) {
    this._monthsLong = value;
  }

  get processingFee(): number {
    return this._processingFee;
  }

  set processingFee(value: number) {
    this._processingFee = value;
  }

  get monthlyPaymentWithProcessingFee(): number {
    return this._monthlyPaymentWithProcessingFee;
  }

  set monthlyPaymentWithProcessingFee(value: number) {
    this._monthlyPaymentWithProcessingFee = value;
  }
}

/**
 * Helper class to map SessionRequest DTO to Session model
 */
export class SessionMapper {
  /**
   * Maps a SessionRequest DTO to a Session model instance
   * @param request The SessionRequest DTO from the backend
   * @returns A new Session instance
   */
  static toSession(request: SessionRequest): Session {
    return new Session(
      request.sessionGuid,
      new Date(request.expiresAt),
      request.cartAmount,
      request.monthlyPayment,
      request.monthsLong,
      request.processingFee,
      request.monthlyPaymentAndProcessingFee,
    );
  }
}
